"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripTrailingSlash = exports.stripLeadingSlash = void 0;
var lodash_1 = require("lodash");
var splitHashParams_1 = __importDefault(require("./splitHashParams"));
var splitUrl_1 = __importDefault(require("./splitUrl"));
var stripFromString = function (regexOrString, string) {
    if (string === void 0) { string = ''; }
    return string.replace(regexOrString, '');
};
exports.stripLeadingSlash = lodash_1.partial(stripFromString, /^\/+/);
exports.stripTrailingSlash = lodash_1.partial(stripFromString, /\/+$/);
var stripTerminalSlashes = lodash_1.flow(exports.stripLeadingSlash, exports.stripTrailingSlash);
/**
 * Strips possible leading and trailing slashes and
 * then adds them back to ensure they're always there
 * and not doubled up. It's important to have the slashes
 * to prevent something like `/dashboard` from matching
 * `/dashboard-items` which is likely a completely
 * different route.
 *
 * If the `retainHashOrQuery` argument is passed as truthy, then it
 * will retain the hash or query string attached to the original `pathname`.
 */
var normalizePathname = function (pathname, retainHashOrQuery) {
    if (retainHashOrQuery === void 0) { retainHashOrQuery = false; }
    var query = splitUrl_1.default(pathname);
    var hash = splitHashParams_1.default(query.baseHref);
    var cleanPath = "/" + stripTerminalSlashes(hash.baseHref) + "/";
    if (retainHashOrQuery) {
        var hashStr = lodash_1.isEmpty(hash.queryString) ? '' : "#" + hash.queryString;
        var queryStr = lodash_1.isEmpty(query.queryString) ? '' : "?" + query.queryString;
        return "" + cleanPath + queryStr + hashStr;
    }
    return cleanPath;
};
exports.default = normalizePathname;
